import React from "react";
import { utcToDate } from "../../utils/dateConvert";
import { getFriendlyHeading, rounding } from "../../utils/math";
import axios from "axios";
import { apiHost } from "../../api/apiClient";

class RealMapBubble extends React.Component {
  state = {
    address: "",
    isLoadingAddress: true
  };

  componentDidMount() {
    this.fetchAddress();
  }

  fetchAddress = async () => {
    const { lat, lng } = this.props.data;
    try {
      const response = await axios.get(`${apiHost}/api/Assets/GetLocationAddress?Latitude=${lat}&Longitude=${lng}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status === 200) {
        this.setState({ 
          address: response.data,
          isLoadingAddress: false
        });
      }
    } catch (e) {
      this.setState({ isLoadingAddress: false });
      if (e.response?.status === 401) {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleFriendlyName = (value) => {
    if (!value) return "";
    return "(" + value + ")";
  };

  handleParking = (value) => {
    return parseInt(value) === 1 ? "No" : "Yes";
  };

  handleGprs = (value) => {
    return parseInt(value) === 1 ? "Online" : "Offline";
  };

  render() {
    const { data } = this.props;
    const { address, isLoadingAddress } = this.state;

    return (
      <div className="mapDetailPopUp">
        <p className="heading">
          <strong>
            <a href={`/Track?assetId=${data.assetId}&assetName=${data.name}`} target="_blank" rel="noopener noreferrer">
              {data.name}
            </a>
          </strong>
          {this.handleFriendlyName(data.friendlyName)}
        </p>
        <br />
        <p>
          <strong>Address</strong>: {isLoadingAddress ? (
            <span>Loading...</span>
          ) : address}
        </p>
        <br />
        <p>
          <strong>Direction</strong>: {getFriendlyHeading(data.heading)}
        </p>
        <br />
        <p>
          <strong>Parked</strong>: {this.handleParking(data.parking)}
        </p>
        <br />
        <p>
          <strong>Since</strong>: {data.lastStatusChange ? utcToDate(data.lastStatusChange) : ""}
        </p>
        <br />
        <p>
          <strong>Speed</strong>: {rounding(data.speed)}
        </p>
        <br />
        <p>
          <strong>Trip</strong>: {data.trip}
        </p>
        <br />
        <p>
          <strong>Odometer</strong>: {data.odometer}
        </p>
        <br />
        <p>
          <strong>Volts</strong>: {data.volt}
        </p>
        <br />
        <p>
          <strong>GPRS</strong>: {this.handleGprs(data.gprs)}
        </p>
        <br />
        <p>
          <strong>Satelites</strong>: {data.satelite}
        </p>
        <br />
        <p>
          <strong>Temp A</strong>: {data.tempA}
        </p>
        <br />
        <p>
          <strong>Temp B</strong>: {data.tempB}
        </p>
        <br />
        <p>
          <strong>Fridge</strong>: {data.fridge}
        </p>
        <br />
        <p>
          <strong>Last Updated</strong>: {utcToDate(data.lastUpdated)}
        </p>
        <br />
        <p>
          <strong>Last Duress</strong>: {utcToDate(data.lastDuress)}
        </p>
        <br />
        <p>
          <strong>Last Powercut</strong>: {utcToDate(data.lastPowerCut)}
        </p>
        <br />
      </div>
    );
  }
}

export default RealMapBubble;
